import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
  },

  // To ensure we get errors in dev (for better debugging) but not in production
  // If app is slow in testing, just comment this line out to see the real speed!
  // https://forum.vuejs.org/t/adding-many-objects-to-vuex-state-is-slow/10492/10

  // strict: process.env.NODE_ENV !== "production",
});

export default store;
